module.exports = __webpack_public_path__ + "img/crop.1e61c75b.svg";